import { render, staticRenderFns } from "./ApproverSettingsModal.vue?vue&type=template&id=84f59d60&scoped=true&lang=pug"
import script from "./ApproverSettingsModal.vue?vue&type=script&lang=js"
export * from "./ApproverSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./ApproverSettingsModal.vue?vue&type=style&index=0&id=84f59d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f59d60",
  null
  
)

export default component.exports